module.exports = __webpack_public_path__ + "static/media/fuel-filter-life-remaining.417e8893.svg";